import { Box, DialogContent, DialogTitle } from "@mui/material";
import { workOrderBusiness } from "api/bussiness/work-order/work-order-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IUpdateDepartmentProcessItem } from "mobx-stores/_models/work-order/work-order-item";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateDepartmentProcessFormSchema } from "./schema";

export const UpdateDepartmentProcess = observer(() => {
  const {
    workOrderManagement: {
      getWorkOrderDetail,
      workOrderDetail,
      updateDepartmentProcess: { open, type, amount, date, reset, woItemId },
    },
  } = useStores();
  const {
    form: { controls },
    submitHandler,
  } = useForm<IUpdateDepartmentProcessItem>(
    getUpdateDepartmentProcessFormSchema(),
    {
      type: type || 0,
      amount: amount || 0,
      date: date || dateTimeToUTCString(dayjs()),
    }
  );
  const onCloseHandler = useCallback(() => {
    reset();
  }, [reset]);

  const saveHandler = useCallback(
    async (data: IUpdateDepartmentProcessItem) => {
      if (!woItemId || data.type == null) return;
      await workOrderBusiness.updateDepartmentProcess(woItemId, data);
      if (workOrderDetail?.id) {
        await getWorkOrderDetail(workOrderDetail?.id);
      }
      onCloseHandler();
    },
    [getWorkOrderDetail, onCloseHandler, woItemId, workOrderDetail?.id]
  );
  return (
    <DialogForm
      open={open}
      fullWidth
      maxWidth={"sm"}
      onClose={onCloseHandler}
      onCancelBtnClicked={onCloseHandler}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
    >
      <DialogTitle>Cập nhật</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
